// Card #2483 (Scoreboard 2.0, docs/score/scoreboard-2.0.md "Mode types", spec
// type 4) -- During/Mid-Ride [Simple]: who is riding in the ring RIGHT NOW.
// Class number/name and test name on top, then the rider's CNO, name,
// status/division and horse, centred; the QR to the class result page is the
// frame's own QR corner (isQrCapableModeType gates it, ScoreboardPage.jsx), so
// nothing here renders it.
//
// A standalone layout, deliberately NOT a branch of SingleEntryLayout: that
// file owns RIDE_INTRO_DETAILED (an AC7-frozen live mode) and POST_RIDE_SCORE,
// and this card may not change either one's markup or CSS. Matches
// demo/scoreboard/2.0/type4-mid-ride-simple.html.
//
// Nothing composable (every bundle absent or empty) never reaches this
// component: classifyBoardRenderState routes it to the Blank fallback first.
import ClassHeader from "./ClassHeader";
import Banner from "./Banner";
import "./MidRideSimpleLayout.css";
import { cleanRiderStatus } from "score-common/rider-status";

export default function MidRideSimpleLayout({ fields, banner }) {
  const id = fields?.entryIdentity || {};
  // #3177: a boolean-ish riderStatus (Yes/No/True/False) is never rendered.
  const riderStatus = cleanRiderStatus(id.riderStatus);
  return (
    <div className="scoreboard-mid-ride" data-testid="scoreboard-mid-ride">
      <ClassHeader classNumberName={fields?.classNumberName} testName={fields?.testName} />
      <div className="mid-ride__body" data-testid="mid-ride-body">
        <Banner banner={banner} />
        {id.competitorNumber != null ? (
          <div className="mid-ride__cno" data-testid="entry-identity-cno">
            #{id.competitorNumber}
          </div>
        ) : null}
        {id.riderName ? (
          <div className="mid-ride__rider" data-testid="entry-identity-rider">
            {id.riderName}
          </div>
        ) : null}
        {id.riderName && typeof id.section === "string" && id.section !== "" ? (
          // #3296: the rider's equitation section, secondary text; absent renders nothing.
          <div className="mid-ride__section" data-testid="entry-identity-section">
            {id.section}
          </div>
        ) : null}
        {riderStatus ? (
          <div className="mid-ride__div" data-testid="entry-identity-status">
            {riderStatus}
          </div>
        ) : null}
        {id.horseName ? (
          <div className="mid-ride__horse" data-testid="entry-identity-horse">
            {id.horseName}
          </div>
        ) : null}
      </div>
    </div>
  );
}
